import { LOCATION_CHANGE } from 'react-router-redux';
import { takeEvery } from 'redux-saga/effects';

import * as routerSagas from './routerSagas';

export default function* register() {
	yield takeEvery(LOCATION_CHANGE, routerSagas.routerLocationChangeSaga);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js